import React from 'react';
import { motion } from 'framer-motion';
const topics = [{
  num: '01',
  title: 'Mentalidad correcta para vender iPhones con publicidad',
  desc: 'Por qué recibir muchos mensajes no significa vender más y cómo pensar tus campañas desde la calidad de la conversación.'
}, {
  num: '02',
  title: 'Análisis comercial antes de pautar',
  desc: 'Cómo revisar ventas, stock, margen y modelos ganadores antes de invertir en anuncios.'
}, {
  num: '03',
  title: 'Buyer persona para tiendas de iPhone',
  desc: 'Cómo diferenciar compradores por intención, presupuesto, equipo actual y forma de pago.'
}, {
  num: '04',
  title: 'Plan canje como filtro de calidad',
  desc: 'Cómo usar el equipo actual del cliente para atraer personas con más intención y reducir consultas inútiles.'
}, {
  num: '05',
  title: 'Creación de ofertas para iPhones',
  desc: 'Cómo presentar precio, financiación, garantía, estado del equipo, stock y plan canje de forma atractiva.'
}, {
  num: '06',
  title: 'Anuncios para Instagram',
  desc: 'Cómo crear hooks, copies y guiones para anuncios que generen conversaciones reales.'
}, {
  num: '07',
  title: 'Campañas de mensajes',
  desc: 'Cómo estructurar campañas de mensajes, separar modelos, testear anuncios y optimizar resultados.'
}, {
  num: '08',
  title: 'Tráfico al perfil',
  desc: 'Cómo usar el perfil como vidriera para aumentar confianza y convertir más visitas en conversaciones.'
}, {
  num: '09',
  title: 'Remarketing',
  desc: 'Cómo volver a impactar a personas que preguntaron, vieron contenido o visitaron tu tienda online.'
}, {
  num: '10',
  title: 'Análisis y optimización',
  desc: 'Qué métricas mirar y cómo saber si el problema está en el anuncio, la oferta, el stock o la atención.'
}];
export function Modules() {
  return <section id="temas" className="py-20 md:py-32 bg-zinc-950" data-id="element-169">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight" data-id="element-172">
            Qué incluye la guía
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-173">
          {topics.map((topic, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 hover:border-blue-500/50 transition-colors group" data-id="element-174">
              <div className="text-blue-500 font-mono text-sm font-bold mb-3 opacity-80" data-id="element-175">
                Tema {topic.num}
              </div>
              <h3 className="text-lg font-bold text-white mb-3 group-hover:text-blue-400 transition-colors" data-id="element-176">
                {topic.title}
              </h3>
              <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-177">
                {topic.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}